import React, { useState, } from 'react';
import { midas, variables } from '@resurs/midas';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import zxcvbn from 'zxcvbn-lite';
import { classNames } from '@resurs/hephaestus';
const PasswordInput = ({ id, name, label, placeholder, peek, creation, creationLabels, size = 'normal', required, peekLabel, onChange, dataCy, autoComplete = 'off', }) => {
    const [isVisible, setVisible] = useState(false);
    const [isRequired, setRequired] = useState(false);
    const [score, setScore] = useState(-1);
    const handleChange = (event) => {
        setScore(zxcvbn(event.target.value).score);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleInvalid = (event) => {
        event.preventDefault();
        setRequired(true);
    };
    const background = () => {
        switch (score) {
            case 0:
                return variables.controlColorDanger;
            case 1:
                return variables.controlColorWarning;
            case 2:
            case 3:
            case 4:
                return variables.controlColorSuccess;
            default:
                return variables.coreColor;
        }
    };
    const strengthMeter = () => (React.createElement("div", { className: midas.mt5 },
        score >= 0 &&
            Array.from(Array(5).keys()).map((i) => (React.createElement("div", { key: `progress_${i}`, style: {
                    width: '23px',
                    height: '4px',
                    display: 'inline-block',
                    background: score >= i ? background() : 'gray',
                    marginRight: '2px',
                } }))),
        React.createElement("div", null,
            React.createElement("small", null, creationLabels === null || creationLabels === void 0 ? void 0 : creationLabels[score]))));
    const labelText = label ? (React.createElement("label", { className: midas.formLabel, htmlFor: id },
        label,
        " ",
        required && React.createElement("span", null, "*"))) : null;
    const inputProps = {
        id,
        name,
        className: classNames(midas.formInput, size === 'small' && midas.inputSm, size === 'large' && midas.inputLg, size === 'xlarge' && midas.inputXl),
        type: isVisible ? 'text' : 'password',
        autoComplete,
        placeholder,
        required,
        onChange: handleChange,
        onInvalid: handleInvalid,
        onFocus: () => setRequired(false),
    };
    const showPassword = (React.createElement("div", { className: midas.mt5 },
        React.createElement("label", { className: midas.formCheckbox },
            React.createElement("input", { type: "checkbox", onChange: () => setVisible(!isVisible) }),
            React.createElement("i", { className: midas.formIcon }),
            " ",
            peekLabel)));
    const requiredValue = isRequired && (React.createElement("span", { className: midas.formInputHint }, required));
    const input = React.createElement("input", { ...inputProps });
    return (React.createElement("div", { className: classNames(midas.formGroup, isRequired && midas.hasWarning), "data-cy": dataCy },
        labelText,
        input,
        peek && showPassword,
        " ",
        creation && strengthMeter(),
        requiredValue));
};
export default PasswordInput;
